import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: "app-calificacion-reprobados",
  templateUrl: "./reprobados.component.html"
})
export class CalificacionReprobadosComponent implements OnInit{
  dato = [];
  periodo_escolar;
  carrera_plan;
  profesor;
  cargando = false;
  borrarCargando = false;

  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };
  time_cal;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");

  tieneid: boolean = false;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));

  grupo = null;
  materia = '';
  materias = null;
  opciones_calificacion = null;
  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private notificacion: NotificationsService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    document.getElementById("catalogos").click();
  }

  cargarDatos(materia, periodo_escolar, profesor, grupo) {
    if (materia.hasOwnProperty("value")) {
      this.materia = materia.value;
    }else{
      this.materia = materia;
    }
    this.dato = [];
    this.grupo = null;
    this.carrera_plan = null;
    this.cargando = true;
    let param = {
      periodo: periodo_escolar,
      profesor: profesor,
      grupo: grupo
    };
    this.crudService.ver(materia, "calificacion-reprobados", param).subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.dato = resultado.data;
          this.opciones_calificacion = resultado.opciones_calificacion;
          this.grupo = resultado.grupo;
          this.materias = resultado.materia;
          this.profesor = resultado.profesor;
          this.carrera_plan = resultado.carrera_plan;
          document.getElementById("CaragarLogos").click();
        } else {
          this.mensajeResponse.titulo = "No hay reprobados";
          this.mensajeResponse.texto = "En este grupo";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Algo salio mal";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  enviar() {
    this.cargando = true;
    document
      .getElementById("confirmarCalificacion")
      .classList.remove("is-active");
    this.crudService.crear(this.dato, "calificacion-reprobados").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          this.mensajeResponse.titulo = "Guardado";
          this.mensajeResponse.texto = "Se ha guardado correctamente";
          this.mensajeResponse.clase = "success";
          this.mensaje(3);
          document.getElementById("actualizar").click();
        } else {
          this.mensajeResponse.titulo = "No guardado";
          this.mensajeResponse.texto = "NO se ha guardado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Ocurrio un error inesperado ";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  validar_max(event, modelo, max) {
    if (
      event.key != "Tab" &&
      event.key != "CapsLock" &&
      event.key != "Shift" &&
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cal);
      this.time_cal = setTimeout(() => {
        if (modelo > max) {
          event.srcElement.value = max;
          modelo = max;
          this.mensajeResponse.titulo = "Maximo";
          this.mensajeResponse.texto =
            "El maximo valor para las calificaciones de este nivel es: " + max;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      }, 500);
    }
  }
  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  logo_sucursal;
  logo_empresa;
  logo_carrera;
  imprimirCalificacion(calif){
    let conteo = 0;
    let doc = new jsPDF('p', 'mm', 'letter');

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 7, 5, 20, 20, "left", "FAST");

    if (this.logo_carrera != '')
      doc.addImage(this.logo_carrera, "PNG", 168, 5, 20, 20, "right", "FAST");
    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre,108, 12,  {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre,108, 18,  {align:"center"});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre,110, 24,  {align:'center'});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text('REPROBADOS',110, 30,  {align:'center'});

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    doc.text("CARRERA: " + this.carrera_plan.planes_estudios.nombre +' - ' + this.carrera_plan.carreras.nombre,10, 40,  {align:"left"});
    doc.text(this.grupo.periodos_escolares.tipos_periodos.nombre_para_mostrar + ': ' + this.grupo.nivel,10, 45,  {align:'left'});
    doc.text("MATERIA: " + this.materias.nombre,10, 50,  {align:"left"});

    doc.text("GRUPO: " + this.grupo.clave+ ' ' + this.grupo.nivel+ ' ' + this.grupo.identificador,100, 40,  {align:"left"});

    doc.text("TURNO: " + this.grupo.turnos.nombre,100, 50,  {align:"left"});


    let columns = [
      { title: "", dataKey: "id" },
      { title: "", dataKey: "alumno" }
    ];
    conteo = 1;
    this.opciones_calificacion.forEach(par => {
      columns.push({
        title: par.nombre,
        dataKey: par.nombre
      });
      conteo++;
    });

    (doc as any).autoTable(columns, [], {
      didParseCell: function(cell, data) {
        cell.styles.fillColor = "#ffffff";
      },
      startY: 56,
      styles: {
        fontSize: 8, font: "arial",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.1
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.1
      },
      bodyStyles: {
        cellPadding: 0.8
      },
      theme: "grid",
      margin: { right: 10, left: 10 },
      columnStyles: {
        id: { cellWidth: 20 },
        alumno: { cellWidth: 60 }
      }
    });

    columns = [
      { title: "N", dataKey: "id" },
      { title: "Nombre del alumno", dataKey: "alumno" }
    ];
    conteo = 1;
    this.opciones_calificacion.forEach(par => {
      columns.push({
        title: "Calf ",
        dataKey: par.nombre
      });
    });

    let rows = []; let linea = 1;
    this.dato.forEach(par => {
      rows.push({
        id: linea,
        alumno: par.alumno.nombre,
      });

      conteo = 1;

      this.opciones_calificacion.forEach(por => {
        rows[linea - 1][por.nombre] = par.calificaciones[por.id] ? par.calificaciones[por.id].promedio : '';
        conteo++;
      });
      linea++;
    });

    (doc as any).autoTable({
            columns:columns, 
            body: rows,
      didParseCell: function(cell, data) {
        cell.styles.fillColor = "#ffffff";
      },
      startY: 62,
      styles: {
        fontSize: 8, font: "arial",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.1
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.1
      },
      bodyStyles: {
        cellPadding: 0.8
      },
      theme: "grid",
      margin: { right: 10, left: 10 },
      columnStyles: {
        id: { cellWidth: 20 },
        alumno: { cellWidth: 60,
          halign: "left"
        }
      }
    });

    doc.text(this.profesor.nombre,50, 250,  {align:"center"});
    doc.line(10, 255, 90, 255);
    doc.text( "DOCENTE",50, 260, {align:"center"});

    doc.line(120, 255, 200, 255);
    doc.text("VO. BO.",160, 260,  {align:"center"});
    doc.text("SERVICIOS ESCOLARES. ",160, 265,  {align:"center"});

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'horario_docente.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/

  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }
}
